import * as React from 'react';
import 'react-datepicker/dist/react-datepicker.css';  // TODO: VIA LESS ?
import {
  WFormData, WFormConfig, WFormConfigItem, WFormFieldText, WFormFieldMail, WFormFieldPassword,
  WFormFieldFoto, WFormFieldSelect, WFormFieldTextSelect, WFormFieldDateTime, WFormFieldCheckbox,
  WFormFieldNumber, WFormFieldCustom, formStyle, WFormFieldArchiv, WFormFieldColor
} from './WFormFramework';
import style from './style/WForm.less';
import classNames from 'classnames';
import { WActionButton } from '../elements/WActionButton';
import { WSpinner } from '../elements/spinner/WSpinner';
import { WFormFieldSelectDialog } from './fields/WFormFieldSelectDialog';
import { Md5 } from 'ts-md5/dist/md5';
import { lazyInject } from '../../services/inversify';
import { LocalDataService } from '../../services/local_data_service';
import { TriggerService } from '../trigger/trigger_service';
import { checkPasswortSecurity } from './helpers/checkPasswortSecurity';
import { WFormFieldRichText } from './fields/WFormFieldRichText';
import { WHelpIcon } from '../elements/WHelpIcon';
import { filterBundleForForm } from '../../bereiche/dateneingabe/functions/filterBundle';
import { ErrorLevel, setErrorLevelAddOn, getErrorLevelKey, removeErrorLevelAddOn } from './helpers/errorLevelTools';
import { getMessageParams } from '../../bereiche/dateneingabe/functions/validateField';
import parse from 'html-react-parser';
import { SimpleDialog } from '../dialog/SimpleDialog';
import { renderText } from '../../bereiche/dateneingabe/assistent/assistent_helpers';
import { i18n } from '../../i18n/i18n';
import { i18n2 } from '../../i18n/i18n_core';
import { getKomplexRowClassname, getCombiFieldKey } from '../../main/functions/getFormKey';

export interface WFormState {
  data: WFormData;
  dataOrig: WFormData;
  valid: boolean;
  errorMsg: string;
  doCopy: boolean;
  validationMsg: any;
  requiredTotal: number;
  requiredMissing: number;
  groupFolded: any;
  fieldsChanged: any;
  mouseClickInfo?: any;
  validMsgPopupStyle: any;
}

interface WFormProps extends React.ClassAttributes<any> {
  containerId?: string;
  useTheme?: number | boolean;
  id?: string;
  module?: string;  // Wird aktuell nur für den Select-Dialog benötigt, optional für den RichText Editor
  entity?: string;
  titel: string;
  layout: string;
  layout2?: string;
  config: WFormConfig;
  dataIn: WFormData;
  readOnly?: boolean;
  showMode?: boolean;
  hideCancel?: boolean;
  hideSave?: boolean;
  showDelete?: boolean;
  showDeleteInSaveDialog?: boolean;
  hiddenFormFields?: Array<string>;
  bundle?: any;
  saveOnEnter?: boolean;
  preset?: any;  // Hier nehmen wir erstmal die preFilter aus WTable
  validRestriction?: string; // 'warning' oder 'stop'
  dualFormContent?: any;
  modeWarning?: string;
  saving?: boolean;
  customCssStyle?: any;
  showRequiredState?: boolean;
  infoMsg?: any;
  selectOptionAsRadio?: boolean;
  showCopy?: boolean;
  customFotoName?: string;
  disableValidateField?: Array<string>;
  showFieldsHelp?: boolean;
  posFieldsHelpBeginning?: boolean;
  hideTitel?: boolean;
  hideLabels?: boolean;
  groupOrder?: Array<any>;
  simpleValidationMsg?: Array<string>;
  valueFieldSelectDefaultOptions?: any;
  disableFieldSelectDefaultOptions?: any;
  enableDidUpdateCheck?: boolean;
  globalData?: any;
  externalDescriptionElement?: JSX.Element | Array<JSX.Element> | string | ((formData: any) => JSX.Element);
  externalTopElement?: JSX.Element | Array<JSX.Element>;
  externalElement?: JSX.Element;
  formAutoSaveDisableOnUnmount?: boolean;
  extraElementBefore?: any;
  extraElementAfter?: any;
  standortSelected?: any;
  hideAllFields?: boolean;
  inComplexForm?: boolean;
  callBeforeOnFormSave?: (data: any, callback: () => void) => void;
  callBeforeOnFormAutoSave?: (data: any, callback: () => void) => void;
  onFormSave(data: WFormData): void;
  onFormAutoSave?(data: WFormData, onWFormUnmount?: boolean): void;
  onFormChange?(data: WFormData, item?: any): void;
  onFormChangeInteractive?(data: WFormData, onValueChange: (name: string, value: any) => void): void;
  onFormDelete?(data: WFormData): void;
  onFormCancel(): void;
  validateField?(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void): string;
  filterOptions?(options: Array<any>, key: string, data: any): Array<any>;
  isPruefung?: boolean; // Flag für AssistentPruefer
  onValidationStateChange?(state: any): void;
  // Hinweis, data beinhaltet alle Daten wg. Quer-Prüfungen
  // onValueChange geben wir mit, damit beim validate auch andere Werte ggf. manipuliert werden können.
}

export class WForm extends React.Component<WFormProps, WFormState> {

  constructor(props: any) {
    super(props);
    const dataOrig = new WFormData();
    dataOrig.setAllValues({ ...this.props.dataIn.getAllValues() });
    dataOrig.setBundle({ ...this.props.bundle });
    // console.log('Constructor: ', this.props.entity, dataOrig.getValue('jahr') ? dataOrig.getValue('jahr') : '---');
    this.state = {
      data: this.props.dataIn,
      dataOrig: dataOrig,
      valid: false,
      errorMsg: '',
      validationMsg: {},
      requiredTotal: -1,
      requiredMissing: -1,
      doCopy: false,
      fieldsChanged: {},
      validMsgPopupStyle: {},
      groupFolded: Array.isArray(props.groupOrder) ? props.groupOrder.map((g: any) => g.folded === true ? true : false) : []
    };
    this.onValueChange = this.onValueChange.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.onClickCancel = this.onClickCancel.bind(this);
    this.validate = this.validate.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.style = style;
    this.formContainerRef = React.createRef();
    this.doAutoSave = this.doAutoSave.bind(this);
  }

  protected style: any;
  private askedForSave = false; // Wir wollen max. 1x Fragen, ob gespeichert werden soll, danach geht nur manuell
  private useLocalStorageBuffer = false;
  private config = require('../../wips.config.js');
  private formContainerRef: any = null;
  private TimeOutDoAutoSave: any;

  public static validMsgColumnWidth = 500;
  public static maxValidMsgWidth = 250;

  @lazyInject(LocalDataService) private localDataService: LocalDataService;
  @lazyInject(TriggerService) private triggerService: TriggerService;

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.props.enableDidUpdateCheck && prevProps.dataIn && this.props.dataIn) {
      const valuesOld = prevProps.dataIn.getAllValues();
      const valuesNew = this.props.dataIn.getAllValues();
      // Es validiert auch wenn sich dataIn geändert hat.
      const diff = Object.keys(valuesNew).some((k: string) => valuesOld.hasOwnProperty(k) && valuesOld[k] !== valuesNew[k]);
      if (diff) {
        this.validate();
      }
    }
  }
  UNSAFE_componentWillMount() {
    // Hier das Preset übernehmen
    if (this.props.config && Array.isArray(this.props.config.items)) {
      const items = this.props.config.items;
      items.forEach((item) => {
        // if (item.hidden) {
        // Wenn der Wert hidden ist, dann erwarte ich, dass der als preset mitkommt.
        // console.log('Preset? ', this.props.preset, item);
        const data = this.state.data;
        if (!data.getValue(item.key) && this.props.preset && this.props.preset[item.key]) {
          // console.log('Preset setzen: ' + item.key + ' = ' + this.props.preset[item.key]);
          const value = typeof this.props.preset[item.key] === 'function' ? this.props.preset[item.key]() : this.props.preset[item.key];
          data.setValue(item.key, value);
          this.setState({ data });
        }
        // }
      });
    }
  }
  componentWillUnmount() {
    // Beim Unmont muss die AutoSaveFunktion sofort getriggert werden.
    if (typeof this.props.onFormAutoSave === 'function' && !this.props.formAutoSaveDisableOnUnmount) {
      if (typeof this.props.callBeforeOnFormAutoSave === 'function') {
        this.props.callBeforeOnFormAutoSave(this.state.data.getAllValues(), () => this.props.onFormAutoSave(this.state.data, true));
      } else {
        this.props.onFormAutoSave(this.state.data, true);
      }
    }
  }
  onClickSave() {
    const data = this.state.data;
    const doClickSave = () => {
      if (!this.state.valid) {
        if (this.props.validRestriction === 'stop') {
          console.log('VALID-MSG', this.state.validationMsg, this.state.errorMsg);
          alert('Der Datensatz ist ungültig!\nBitte korrigieren / vervollständigen Sie Ihre Eingaben!');
          return;
        } else if (this.props.validRestriction !== 'ignore') {
          const errorMsg: string = (Object.values(this.state.validationMsg || {}))
            .map((str: string) => removeErrorLevelAddOn(str)).join(', ');
          const text: string = Object.keys(this.state.validationMsg || {}).length > 1
            ? 'Es wurden folgende Probleme festgestellt:'
            : 'Es wurde folgendes Problem festgestellt:';
          const confirm_save = window.confirm(`${text}\r\n${errorMsg}\r\n\r\nWollen sie wirklich speichern?`);
          if (!confirm_save) {
            return;
          }
        }
      }
      // console.log('WForm onClickSave state.data : ');
      const dataOrig = this.state.dataOrig;
      const items = this.props.config.items;
      items.forEach((item) => {
        if (item.typ === 'password' && !item.plain) {
          const value = data.getValue(item.key);
          const valueOrig = dataOrig.getValue(item.key);
          if (valueOrig !== value) {
            data.setValue(item.key, Md5.hashAsciiStr(value));
          }
        }
      });
      if (this.state.doCopy) {
        data.setValue('tid', 0);
        // console.log('Values!', data.getAllValues());
      }
      this.props.onFormSave(this.state.data);
      if (this.useLocalStorageBuffer) {
        this.localDataService.remove(JSON.stringify(this.props.config));
      }
    };

    if (this.props.callBeforeOnFormSave) {
      this.props.callBeforeOnFormSave(data.getAllValues(), doClickSave);
    } else {
      doClickSave();
    }
  }
  onClickDelete() {
    if (this.props.onFormDelete && window.confirm('Diesen Datensatz wirklich löschen ?')) {
      this.props.onFormDelete(this.state.data);
    }
  }
  onClickCancel() {
    this.props.onFormCancel();
  }
  onValueChange(name: string, value: any, doValidate?: boolean) {
    const { data, fieldsChanged } = this.state;
    // console.log('onValueChange', this.props.entity, name, value, data);
    data.setValue(name, value);
    if (data.getValue(name + '_orig')) {
      data.setValue(name + '_orig', value);
    }
    // console.log('WForm valus:', data.getAllValues());

    const items = this.props.config ? this.props.config.items : [];
    const item = items.find((i: any) => i.key === name);
    const bundleData = this.getBundleData(item);
    const bundleFiltered = filterBundleForForm(this.props.entity, name, bundleData, data.getAllValues(),
      this.props.standortSelected, this.props.globalData, this.onValueChange);
    data.setBundleByKey(name, bundleFiltered);

    fieldsChanged[name] = true;
    this.setState({ data, fieldsChanged }, () => {
      // Wichtig, validate erst nachdem der State geschrieben ist!
      // console.log('WForm onValueChange:' + name, value, doValidate, fieldsChanged);
      if (doValidate !== false) {
        this.validate(this.doAutoSave);
      } else {
        this.doAutoSave();
      }

      if (this.useLocalStorageBuffer) {
        this.localDataService.set(JSON.stringify(this.props.config), JSON.stringify(this.state.data.getAllValues()));
      }
      if (this.props.onFormChange || this.props.onFormChangeInteractive) {
        if (this.props.onFormChange) {
          this.props.onFormChange(data, item);
        }
        if (this.props.onFormChangeInteractive) {
          this.props.onFormChangeInteractive(data, this.onValueChange);
        }
        this.setState({ data });
      }
      // console.log('SET AUTOSAVR', JSON.stringify(this.state.data));
    });
  }
  doAutoSave() {
    if (typeof this.props.onFormAutoSave === 'function') {
      clearTimeout(this.TimeOutDoAutoSave);
      this.TimeOutDoAutoSave = setTimeout(() => {
        if (typeof this.props.callBeforeOnFormAutoSave === 'function') {
          this.props.callBeforeOnFormAutoSave(this.state.data.getAllValues(), () => this.props.onFormAutoSave(this.state.data));
        } else {
          this.props.onFormAutoSave(this.state.data);
        }
      }, 1000);
    }
  }
  componentDidMount() {
    // console.log('Mount: ', this.props.entity,
    //                         this.state.dataOrig.getValue('jahr') ? this.state.dataOrig.getValue('jahr') : '---');
    const dataBuffered = this.useLocalStorageBuffer ? this.localDataService.get(JSON.stringify(this.props.config)) : undefined;
    // console.log('TID', this.state.data.getValue('tid'), dataBuffered);
    const tid = this.state.data ? this.state.data.getValue('tid') : undefined;
    if (dataBuffered && (!tid || tid <= 0)) {
      if (false && window.confirm('Ein nicht abgeschlossener Datensatz wurde gefunden. Soll dieser wiederhergestellt werden?')) {
        const data = this.state.data;
        data.setAllValues(JSON.parse(dataBuffered));
        this.setState({ data }, () => this.validate());
      } else {
        this.validate();
      }
    } else {
      this.validate();
    }
  }
  validate(callBackOnValid?: () => void) {
    const items = this.props.config ? this.props.config.items : [];
    // console.log(items);
    const validationMsg: any = {};
    let errorMsg = '';
    let valid = true;
    let requiredTotal = 0;
    let requiredMissing = 0;
    items.forEach((item: any) => {
      const disableValidate = Array.isArray(this.props.disableValidateField)
        && this.props.disableValidateField.indexOf(item.key) !== -1 ? true : false;
      if (item.disabled || item.hidden || item.hidden_input || disableValidate ||
        (this.props.hiddenFormFields && this.props.hiddenFormFields.indexOf(item.key) > -1)) {
        return; // Bei diesen Items hat der User keine Chance, deshalb auch keine Validation
      }
      const value = this.state.data.getValue(item.key);
      let required_ok = true;
      let required = item.required;
      if (item.condition_required) {
        const field = item.condition_required.field;
        const refvalue = item.condition_required.value;
        const checkvalue = this.state.data.getValue(field);
        if (refvalue === checkvalue) {
          required = true;
        } else {
          required = false;
        }
      }
      if (required) {
        // console.log(item.name, value, item);
        requiredTotal++;
        if (value === undefined || value === '' || value === null || (item.typ === 'select' && value == 0)) {
          const infoMsg = setErrorLevelAddOn('Bitte Feld \'' + item.label + '\' ausfüllen', ErrorLevel.info);
          valid = false;
          if (errorMsg !== '') {
            errorMsg += ', ';
          }
          errorMsg += infoMsg;
          required_ok = false;
          requiredMissing++;
          if (validationMsg[item.key]) {
            validationMsg[item.key] += ', ' + infoMsg;
          } else {
            validationMsg[item.key] = infoMsg;
          }
        }
      }
      if (item.typ === 'mail') {
        // tslint:disable-next-line: max-line-length
        const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        // console.log('mail-validation erreicht. formatOk :');
        const formatOk = regexp.test(value);
        // console.log(formatOk);
        if (value && value !== '' && !formatOk) {
          const infoMsg = setErrorLevelAddOn('Keine gültige E-Mail-Adresse', ErrorLevel.warning);
          valid = false;
          if (validationMsg[item.key]) {
            validationMsg[item.key] += ', ' + infoMsg;
          } else {
            validationMsg[item.key] = infoMsg;
          }
        }
      }
      // Jetzt Custom - Validation - aber nur, wenn es nicht schon mit dem Required ein Problem gab
      if (required_ok && !disableValidate) { // OK, es gibt einen Custom - Validator
        if (this.config && this.config.enablePasswordPolicy === true && item.typ === 'password') {
          let res;
          if (!this.state.fieldsChanged[item.key]) {
            // Bleibt das Passwort umgeändert, muss nicht validieret werden
            res = true;
          } else {
            const password_confirm = item.confirm_required ? (this.state.data.getValue(item.key + '_confirm') || '') : null;
            res = checkPasswortSecurity(value, password_confirm);
          }
          if (res !== true) {
            valid = false;
            const validationResult = res;
            if (errorMsg !== '') {
              errorMsg += ', ';
            }
            errorMsg += validationResult;
            if (validationMsg[item.key]) {
              validationMsg[item.key] += ', ' + validationResult;
            } else {
              validationMsg[item.key] = validationResult;
            }
          }
        }
        if (this.props.validateField) {
          const validationResult = this.props.validateField(item.key, value, this.state.data, this.onValueChange);
          if (validationResult && validationResult !== '') {
            valid = false;
            if (errorMsg !== '') {
              errorMsg += ', ';
            }
            errorMsg += validationResult;
            if (validationMsg[item.key]) {
              validationMsg[item.key] += ', ' + validationResult;
            } else {
              validationMsg[item.key] = validationResult;
            }
          }
        }
      }
    });
    this.setState({ valid, errorMsg, validationMsg, requiredTotal, requiredMissing }, () => {
      if (valid && typeof callBackOnValid === 'function') {
        callBackOnValid();
      }
      if (this.props.onValidationStateChange) {
        this.props.onValidationStateChange(validationMsg);
      }
    });
  }

  renderItem(item: WFormConfigItem, errorLevelKey?: string, forCombi?: boolean) {
    const { customCssStyle, layout, id } = this.props;
    const customStyleField = customCssStyle && customCssStyle.formField && customCssStyle.formField[item.key] ?
      customCssStyle.formField[item.key] : null;
    const customStyleLabel = ((customCssStyle || {}).label || {})[item.key] || {};
    const labelExtra = this.state.data.getLabelExtra(item.key);

    let value = this.state.data.getValue(item.key);
    if (this.state.data.getValue(item.key + '_orig')) {
      value = this.state.data.getValue(item.key + '_orig');
    }
    if (!value) {
      if (this.props.preset && this.props.preset[item.key]) {
        value = this.props.preset[item.key];
      }
    }
    //  console.log('ITEM/VALUE:', item, value);
    if (item.typ === 'formula') {
      const row = this.state.data.getAllValues();
      // tslint:disable-next-line:no-eval
      value = eval(item.formula);
    }
    // console.log(item.key + ' = ' + value);
    const prefix = 'field';
    if (item.show !== true && (item.hidden || (this.props.hiddenFormFields && this.props.hiddenFormFields.indexOf(item.key) > -1))) {
      // Wir müssen auch wenn das Item hidden ist, das Bundle filtern, da dort ggf. trigger dranhängen (siehe filterBundleForForm)
      let bundleData = this.getBundleData(item);
      if (bundleData) {
        bundleData = filterBundleForForm(this.props.entity, item.key, bundleData, this.state.data.getAllValues(),
          this.props.standortSelected, this.props.globalData, this.onValueChange);
      }
      return;
    }
    if (item.combination_item && !forCombi) {
      return;
    }
    if (item.condition_showing) {
      const field = item.condition_showing.field;
      const refvalue = item.condition_showing.value;
      const checkvalue = this.state.data.getValue(field);
      if (refvalue !== checkvalue) {
        return;
      }
    }
    let required = item.required;
    if (item.condition_required) {
      const field = item.condition_required.field;
      const refvalue = item.condition_required.value;
      const checkvalue = this.state.data.getValue(field);
      if (refvalue === checkvalue) {
        required = true;
      } else {
        required = false;
      }
    }
    if (this.props.readOnly) {
      item.readonly = true;
    }

    // console.log(item);

    if (item.typ === 'combination') {
      return this.renderCombination(item);
    }

    const labelClass = formStyle.label;
    const labelText = this.renderLabelText(item, labelExtra);
    const label = this.renderLabel(item, labelText, labelClass, customStyleLabel);
    const fieldId = id ? id + '_' + item.key : null;

    if (this.props.hideAllFields) {
      return <WFormFieldCustom
        label={label}
        name={item.key}
        layout={this.props.layout}
        fieldType={item.typ}
        value={''}
        row={this.state.data.getAllValues()}
        onValueChange={() => { }}
        readonly={true}
        disabled={true}
        key={prefix + item.key}
        custom_component={() => <div />}
        custom_renderer={() => <div />}
        custom_setCloseHandler={() => { }}
      />;
    }

    switch (item.typ) {
      case 'custom':
        return (<WFormFieldCustom
          label={label}
          name={item.key}
          value={value}
          onValueChange={this.onValueChange}
          readonly={item.readonly}
          disabled={item.disabled}
          key={prefix + item.key}
          custom_component={item.custom_component}
          custom_renderer={item.custom_renderer}
          custom_setCloseHandler={item.custom_setCloseHandler}
        />);
      case 'text':
        if (item.format && item.format === 'FARBE') {
          return <WFormFieldColor
            label={label}
            name={item.key}
            value={value}
            onValueChange={this.onValueChange}
            makeDefault={() => { this.onValueChange(item.key, 'transparent'); }}
          />;
        } else if (item.format && item.format === 'RICHTEXT') {
          return <WFormFieldRichText
            label={label}
            name={item.key}
            value={value}
            onValueChange={this.onValueChange}
            height={customCssStyle && customCssStyle.formFieldRichText &&
              customCssStyle.formFieldRichText.height ? customCssStyle.formFieldRichText.height : null}
            module={this.props.module}
          />;
        } else {
          return (<WFormFieldText
            id={fieldId}
            label={label}
            name={item.key}
            hidden_input={item.hidden_input}
            value={value}
            row={this.state.data.getAllValues()}
            onValueChange={this.onValueChange}
            required={required}
            readonly={item.readonly}
            disabled={item.disabled}
            key={prefix + item.key}
            maxLength={item.maxLength}
            placeholder={item.placeholder}
            inComplexForm={this.props.inComplexForm}
            layout={this.props.layout}
            customStyle={customStyleField}
            showMode={this.props.showMode}
            errorLevelKey={errorLevelKey}
          />);
        }
      case 'textarea':
        return (<WFormFieldText
          id={fieldId}
          label={label}
          name={item.key}
          value={value}
          row={this.state.data.getAllValues()}
          onValueChange={this.onValueChange}
          required={required}
          readonly={item.readonly}
          disabled={item.disabled}
          key={prefix + item.key}
          placeholder={item.placeholder}
          isTextarea={true}
          layout={this.props.layout}
          customStyle={customStyleField}
          showMode={this.props.showMode}
          errorLevelKey={errorLevelKey}
        />);
      case 'archiv':
        const row = this.state.data.getAllValues();
        row[item.key] = this.props.dataIn.getValue(item.key);
        return (<WFormFieldArchiv
          entity={this.props.entity}
          label={label}
          name={item.key}
          value={value}
          data={row}
          onValueChange={this.onValueChange}
          required={required}
          readonly={item.readonly}
          hidden_input={item.hidden_input}
          hidden_msg={item.hidden_msg}
          key={prefix + item.key}
          layout={this.props.layout}
          layout2={this.props.layout2}
          disabled={item.disabled}
          globalData={this.props.globalData}
          module={this.props.module}
          format={item.format}
          showMode={this.props.showMode}
        />);
      case 'mail':
        return (<WFormFieldMail
          label={label}
          name={item.key}
          value={value}
          onValueChange={this.onValueChange}
          required={required}
          readonly={item.readonly}
          key={prefix + item.key}
          disabled={item.disabled}
        />);
      case 'number':
        return (<WFormFieldNumber
          id={fieldId}
          data={this.props.globalData}
          label={label}
          name={item.key}
          entity={this.props.entity}
          hidden_input={item.hidden_input}
          value={value}
          row={this.state.data.getAllValues()}
          onValueChange={this.onValueChange}
          required={required}
          readonly={item.readonly}
          key={prefix + item.key}
          disabled={item.disabled}
          layout={this.props.layout}
          customStyle={customStyleField}
          decimals={item.decimals}
          custom_component={item.custom_component}
          maxLength={item.maxLength}
          placeholder={item.placeholder}
          hidden_msg={item.hidden_msg}
          showMode={this.props.showMode}
          errorLevelKey={errorLevelKey}
        />);
      case 'checkbox':
        return (<WFormFieldCheckbox
          label={label}
          name={item.key}
          value={value}
          onValueChange={this.onValueChange}
          required={required}
          readonly={item.readonly}
          key={prefix + item.key}
          disabled={item.disabled}
          style={customStyleField}
        />);
      case 'select':
        const { disableFieldSelectDefaultOptions, valueFieldSelectDefaultOptions } = this.props;
        const disableDefaultOption: boolean = (disableFieldSelectDefaultOptions && disableFieldSelectDefaultOptions[item.key]);
        const valueDefaultOption: string = valueFieldSelectDefaultOptions && valueFieldSelectDefaultOptions[item.key]
          ? valueFieldSelectDefaultOptions[item.key]
          : undefined;
        let bundleData = this.getBundleData(item);
        if (bundleData) {
          bundleData = filterBundleForForm(this.props.entity, item.key, bundleData, this.state.data.getAllValues(),
            this.props.standortSelected, this.props.globalData, this.onValueChange);
        }
        // console.log('Select', item);
        const customStyleFieldSelect = customCssStyle && customCssStyle.formFieldSelect ? customCssStyle.formFieldSelect : {};
        return (
          <WFormFieldSelect
            label={label}
            name={item.key}
            value={value}
            data={this.props.globalData}
            row={this.state.data.getAllValues()}
            onValueChange={this.onValueChange}
            options={bundleData}
            required={required}
            readonly={item.readonly}
            hidden_input={item.hidden_input}
            hidden_msg={item.hidden_msg}
            customStyle={{ ...customStyleFieldSelect, ...customStyleField }}
            disableSearch={item.disableSearch}
            output={item.bundle_output}
            output_condition={item.bundle_output_condition}
            key={prefix + item.key}
            bundle_key={item.bundle_key}
            bundle_value={item.bundle_value}
            bundle_text={item.bundle_text}
            bundle_assign={item.bundle_assign}
            bundle_text_unique={item.bundle_text_unique}
            filterOptions={this.props.filterOptions ? this.props.filterOptions : undefined}
            getFormData={this.props.filterOptions ? () => this.state.data.getAllValues() : undefined}
            layout={this.props.layout}
            asRadio={this.props.selectOptionAsRadio || item.radio}
            asJaNein={item.asJaNein}
            disabled={item.disabled}
            valueDefaultOption={valueDefaultOption}
            disableDefaultOption={disableDefaultOption || item.disable_default}
            // WAEW-215: Auto-Scroll wenn Select-Element unten am Rand steht
            formContainerRef={this.formContainerRef}
            custom_component={item.custom_component}
            showMode={this.props.showMode}
            errorLevelKey={errorLevelKey}
            isCombiItem={forCombi}
            // WKETOOL-113: 189 Im Dropdown soll es möglich sein, eine initiale Option hinzuzufügen
            onMenuOpen={item.event_handler && typeof item.event_handler.onMenuOpen === 'function' ? () => item.event_handler.onMenuOpen({ bundleData }) : null}
            sysTxtKeyHinweis={item.sysTxtKeyHinweis}
          />
        );
      case 'select_dialog':
        const bundleDataDialog = this.getBundleData(item);
        return (<WFormFieldSelectDialog
          module={this.props.module}
          label={label}
          name={item.key}
          value={value}
          onValueChange={this.onValueChange}
          options={bundleDataDialog}
          required={required}
          readonly={item.readonly}
          entity={item.bundle_key}
          fields={item.bundle_fields}
          key={prefix + item.key}
          bundle_value={item.bundle_value}
          bundle_text={item.bundle_text}
          bundle_assign={item.bundle_assign}
          filterOptions={this.props.filterOptions ? this.props.filterOptions : undefined}
          getFormData={this.props.filterOptions ? () => this.state.data.getAllValues() : undefined}
          layout={this.props.layout}
          disabled={item.disabled}
        />);
      case 'textselect':
        const bundleData2 = this.getBundleData(item);
        return (<WFormFieldTextSelect
          label={label}
          name={item.key}
          value={value}
          onValueChange={this.onValueChange}
          options={bundleData2}
          required={required}
          readonly={item.readonly}
          key={prefix + item.key}
          bundle_value={item.bundle_value}
          bundle_text={item.bundle_text}
          bundle_assign={item.bundle_assign}
          filterOptions={this.props.filterOptions ? this.props.filterOptions : undefined}
          getFormData={this.props.filterOptions ? () => this.state.data.getAllValues() : undefined}
          disabled={item.disabled}
        />);
      case 'password':
        return [
          <WFormFieldPassword
            label={label}
            name={item.key}
            value={value}
            onValueChange={this.onValueChange}
            required={required}
            readonly={item.readonly}
            key={prefix + item.key}
            disabled={item.disabled}
          />,
          // Ein 2. Passwort-Feld zur Bestätigung / Wiederholung
          ...(item.confirm_required && !item.disabled && !item.readonly ? [
            <WFormFieldPassword
              label={this.renderLabel(item, this.renderLabelText(item, ' (Wiederholung)'), labelClass)}
              name={item.key + '_confirm'}
              value={this.state.data.getValue(item.key + '_confirm')}
              onValueChange={this.onValueChange}
              key={prefix + item.key + '_confirm'}
            />
          ] : [])
        ];
      case 'foto':
        return (<WFormFieldFoto
          module={this.props.module}
          label={label}
          name={item.key}
          fotoName={this.props.customFotoName ? this.props.customFotoName : 'image'}
          value={value}
          /*
          width = {240}
          height = {180}
          widthCapture = {320}
          heightCapture = {240}
          */
          width={240}
          height={180}
          widthCapture={320}
          heightCapture={240}
          onValueChange={this.onValueChange}
          required={required}
          readonly={item.readonly}
          key={prefix + item.key}
          disabled={item.disabled}
          disableUpload={item.disableUpload ? true : false}
        />);
      case 'datepicker':
        return (<WFormFieldDateTime
          label={label}
          name={item.key}
          value={value}
          row={this.state.data.getAllValues()}
          layout={this.props.layout}
          withTimePicker={false}
          onValueChange={this.onValueChange}
          required={required}
          minDate={item.min_date && new Date(Date.parse(item.min_date))}
          readonly={item.readonly}
          key={prefix + item.key}
          allowFuture={item.allowFuture}
          autofill={item.autofill}
          warn={item.warn ? item.warn : ''}
          disabled={item.disabled}
          WActionButtonStyleProps={(this.props.layout === 'sidebysideComplex' || this.props.layout === 'sidebysideComplexGreen') ?
            {
              width: 15,
              height: 20,
              margin: '0 2px',
              padding: 0
            } : {}}
          allValues={this.state.data.getAllValues()}
          showMode={this.props.showMode}
          custom_component={item.custom_component}
          errorLevelKey={errorLevelKey}
        />);
      case 'datetimepicker':
        return (<WFormFieldDateTime
          label={label}
          name={item.key}
          value={value}
          row={this.state.data.getAllValues()}
          layout={this.props.layout}
          withTimePicker={true}
          onValueChange={this.onValueChange}
          required={required}
          minDate={item.min_date && new Date(Date.parse(item.min_date))}
          readonly={item.readonly}
          key={prefix + item.key}
          autofill={item.autofill}
          disabled={item.disabled}
          allValues={this.state.data.getAllValues()}
          custom_component={item.custom_component}
          errorLevelKey={errorLevelKey}
        />);
      case 'titel': {
        const name: string = item.format === 'SUB' ? 'formTitelLight' : 'formTitel';
        return ((layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen')
          ? <div className={formStyle.fieldBox}>
            {label}
            <div className={classNames(formStyle.input, item.hidden_input ? formStyle.showMode : formStyle[name])}>
              <div style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden' }}>
                {!item.hidden_input ? i18n2(item.label) : ''}
              </div>
            </div>
          </div>
          : <div className={formStyle[name]} style={{ ...((customCssStyle || {}).formTitel ? customCssStyle.formTitel : {}) }}>
            {i18n2(item.label)}
          </div>
        );
      }
    }
  }
  renderFieldsHelp(item: any) {
    const isAssistentLayout: boolean = this.props.layout === 'flowV' || this.props.layout === 'flowV2' || this.props.layout2 === 'assistent';
    const helpKey = (this.props.module ? this.props.module : 'nomodule')
      + '_' + (this.props.entity ? this.props.entity : 'noentity')
      + '_' + ((this.props.entity === 'kennziffern_struct_generated' && item.key !== 'bemerkung') ? 'field' : (item.helpKey || item.key));

    let bgColor = '#b9cde5';
    if (this.props.layout === 'sidebysideComplexGreen') {
      bgColor = '#00b050';
    }

    if (isAssistentLayout) {
      return (
        <WHelpIcon
          containerId={this.props.containerId}
          data={this.props.globalData}
          styleDivProps={{
            // width: 100,
            // textAlign: item.typ === 'select' ? 'right' : 'left',
            marginTop: 6,
            marginLeft: this.props.posFieldsHelpBeginning ? 0 : 10,
            marginRight: this.props.posFieldsHelpBeginning ? 10 : 0
          }}
          styleProps={{
            width: 16, height: 14, borderRadius: 10, backgroundColor: 'transparent', /*verticalAlign: 'top',*/ margin: 0
          }}
          label={'Info "' + item.label + '"'}
          helpKey={helpKey}
          style={'theme_small'}
          type={'theme_info'}
          editBar={true}
          customElement={'Info'}
          useTheme={this.props.useTheme || true}
        />
      );
    } else {
      return (
        <WHelpIcon
          containerId={this.props.containerId}
          data={this.props.globalData}
          styleDivProps={{
            marginLeft: this.props.posFieldsHelpBeginning ? 0 : 10,
            marginRight: this.props.posFieldsHelpBeginning ? 10 : 0,
            display: 'flex', alignSelf: 'center'
          }}
          styleProps={{ margin: 0 }}
          // styleProps={{
          //   width: 18, height: 18, borderRadius: 10, backgroundColor: bgColor, verticalAlign: 'top', margin: 0
          // }}
          label={`Info "${item.label}"`}
          helpKey={helpKey}
          type={'info'}
          editBar={true}
          useTheme={this.props.useTheme || true}
        />
      );
    }
  }
  render() {
    if (this.props.isPruefung) {
      // Prüfung ist ohne Komponente möglich, und schneller!
      return null;
    }

    const conf = this.config;
    if (!conf) {
      return null;
    }
    const formValues = this.state.data.getAllValues();
    const items = this.props.config ? this.props.config.items : [];
    // console.log('Items', items);
    let outerStyle = formStyle.plain;
    if (this.props.layout === 'sidebyside') {
      outerStyle = formStyle.sidebyside;
    } else if (this.props.layout === 'sidebysidesmall') {
      outerStyle = formStyle.sidebysidesmall;
    } else if (this.props.layout === 'sidebysideComplex') {
      outerStyle = formStyle.sidebysideComplex;
    } else if (this.props.layout === 'sidebysideComplexGreen') {
      outerStyle = formStyle.sidebysideComplexGreen;
    } else if (this.props.layout === 'sidebysideWIPS') {
      outerStyle = conf.mediaType && conf.mediaType === 'tablet' ? formStyle.sidebysideWIPS : formStyle.sidebysideWIPSsmall;
    } else if (this.props.layout === 'flow') {
      outerStyle = formStyle.flow;
    } else if (this.props.layout === 'flowV2') {
      outerStyle = formStyle.flowV2;
    }
    if (this.props.module === 'ber' || this.props.layout === 'ber') {
      outerStyle = formStyle.berFormLayout;
    }

    const elemBefore = this.props.extraElementBefore;
    const elemAfter = this.props.extraElementAfter;
    //  console.log('WForm: externalDescriptionElement: ', this.props.externalDescriptionElement);
    const extDescElement = typeof this.props.externalDescriptionElement === 'string' ? parse(this.props.externalDescriptionElement) :
      typeof this.props.externalDescriptionElement === 'function' ? this.props.externalDescriptionElement(formValues) :
        this.props.externalDescriptionElement;

    const isAssistentLayout: boolean = this.props.layout === 'flowV' || this.props.layout === 'flowV2' || this.props.layout2 === 'assistent';
    const validationMsg = this.state.validationMsg || {};
    const showValidMsg: boolean = isAssistentLayout && Object.keys(validationMsg).length > 0;
    // console.log(showValidMsg, validationMsg);

    return (
      <div
        className={outerStyle}
        onKeyPress={this.handleKeyPress}
        style={this.props.customCssStyle && this.props.customCssStyle.outerStyle ? this.props.customCssStyle.outerStyle : null}
      >
        {!this.props.hideTitel && <div className={formStyle.titel}>
          <div
            style={{ padding: '12px' }}
          >
            {this.state.doCopy ? this.props.titel + ' (copy)' : this.props.titel}
          </div>
          {!this.props.readOnly && !this.props.saving && !this.props.hideSave && this.props.layout !== 'flowV2' ? (
            <WActionButton
              label={i18n('Speichern', 'sys')}
              action='formSave'
              key='action_save'
              onAction={() => this.onClickSave()}
              style='big'
            />
          ) : ''
          }
          {this.props.showDelete && !this.props.saving ? (
            <WActionButton
              label={i18n('Löschen', 'sys')}
              action='formDelete'
              key='action_delete'
              onAction={() => this.onClickDelete()}
              style='big'
            />
          ) : ''
          }
          {
            !this.props.hideCancel && !this.props.saving && this.props.layout !== 'flowV2' ?
              <WActionButton
                label='Cancel'
                action='formCancel'
                key='action_cancel'
                onAction={() => this.onClickCancel()}
                style='big'
              /> : ''
          }
          {
            this.props.showCopy &&
            <WActionButton
              label={i18n('Kopieren', 'sys')}
              action='copy'
              key='action_copy'
              onAction={(evt: any) => this.setState({ doCopy: true })}
              style='big'
            />
          }
          {(this.props.showRequiredState && this.state.requiredTotal > 0) &&
            <div>
              {this.state.requiredMissing === 0 ? <div
                style={{
                  backgroundColor: '#4D4', padding: '10px', marginTop: '2px',
                  marginLeft: '3px', borderRadius: '5px', fontSize: '16px'
                }}
              > Pflichtfelder wurden ausgefüllt</div> :
                <div
                  style={{
                    backgroundColor: '#FAA', padding: '10px', marginTop: '2px',
                    marginLeft: '3px', borderRadius: '5px', fontSize: '16px'
                  }}
                > Noch {this.state.requiredMissing} von {this.state.requiredTotal} Pflichtfelder
                </div>}
            </div>
          }
        </div>}
        {extDescElement && <div
          style={{
            padding: 5,
            ...(isAssistentLayout ? { paddingRight: 12, paddingLeft: 3 } : { paddingRight: 0, paddingLeft: 10 })
          }}
        >
          {extDescElement}
        </div>
        }
        {this.props.externalTopElement &&
          <div>
            {this.props.externalTopElement}
          </div>
        }
        <div
          ref={this.formContainerRef}
          className={formStyle.formcontainer}
          style={{
            ...(this.props.customCssStyle && this.props.customCssStyle.formcontainer ? this.props.customCssStyle.formcontainer : {}),
            ...(showValidMsg ? { width: `calc(100% + ${WForm.validMsgColumnWidth}px)`, overflow: 'visible' } : {}),
          }}
        >
          {this.props.groupOrder ?
            this.renderItemsByGroupOrder(items) :
            items.map((item: any, idx: number) => {
              if (this.props.layout === 'sidebysideComplex' || this.props.layout === 'sidebysideComplexGreen') {
                let validMsg: string, elk: string;
                if (Array.isArray(item.combination_fields)) {
                  const vms: Array<string> = [];
                  item.combination_fields.forEach((fKey: string) => {
                    let vm = this.state.validationMsg[fKey];
                    if (vm) {
                      elk = elk || getErrorLevelKey(vm);
                      vm = removeErrorLevelAddOn(vm);
                      vms.push(vm);
                    }
                  });
                  validMsg = vms.join('\n');
                } else {
                  validMsg = this.state.validationMsg[item.key];
                  elk = getErrorLevelKey(validMsg);
                  validMsg = removeErrorLevelAddOn(validMsg);
                }
                const message: any = getMessageParams(validMsg) || {};
                const hasMessage: boolean = !!message.key || (message.isAlert && message.text);
                return <div style={{ position: 'relative', width: '100%' }} key={'item_' + idx}>
                  {elemBefore && elemBefore[item.key || item.id]}
                  {validMsg && !this.props.hideAllFields && !item.combination_item &&
                    <div
                      key={`warn_${formValues.tid}_${idx}}`}
                      className={formStyle.warnSign}
                      style={{ ...(elk === 'warning' && { color: '#616468' }), ...(hasMessage && { cursor: 'pointer' }) }}
                      title={validMsg}
                      onClick={hasMessage ? (event: any) => this.setWarnOnClick(event, { ...message, info: validMsg }) : undefined}
                      ref={hasMessage ? (elem: any) => this.setWarnRef(elem, item, formValues) : undefined}
                    >*</div>
                  }
                  {this.renderItem(item, elk)}
                  {elemAfter && elemAfter[item.key || item.id]}
                </div>;
              } else {
                const itemElemBefore = (elemBefore || {})[item.key || item.id];
                const itemElemAfter = (elemAfter || {})[item.key || item.id];
                return this.renderItemWrapper(item, showValidMsg, itemElemBefore, itemElemAfter);
              }
            })}
          {this.props.externalElement}
        </div>
        <div>
          {this.props.layout === 'flowV2' &&
            <div className={formStyle.buttonWrapper}>
              {!this.props.readOnly && !this.props.saving && this.props.showDeleteInSaveDialog && (formValues.tid > 0) &&
                <button
                  value={i18n('Löschen', 'sys')}
                  title={i18n('Löschen', 'sys')}
                  className={formStyle.textButton}
                  onClick={() => this.onClickDelete()}
                >
                  {'Löschen'}
                </button>}
              {!this.props.readOnly && !this.props.saving && !this.props.hideSave &&
                <button
                  value={i18n('Speichern', 'sys')}
                  title={i18n('Speichern', 'sys')}
                  className={formStyle.textButton}
                  onClick={() => this.onClickSave()}
                >
                  {i18n('Speichern', 'sys')}
                </button>}
            </div>}
        </div>
        {this.props.saving && <WSpinner label={i18n('Senden', 'sys')} />}
        {this.state.mouseClickInfo && this.renderMouseClickInfo()}
      </div>
    );
  }

  renderItemWrapper(item: WFormConfigItem, showValidMsg: boolean, elemBefore?: JSX.Element, elemAfter?: JSX.Element): JSX.Element {
    const width = showValidMsg ? `calc(100% - ${WForm.validMsgColumnWidth}px)` : '100%';
    return <div
      style={{ width: '100%' }}
      key={`item_${item.key || item.id || Md5.hashAsciiStr(JSON.stringify(item)).toString()}`}
    >
      <div
        style={{ width }}
      >
        {elemBefore}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        <div
          style={{ width }}
          onFocus={() => this.setFocusedItem(item.key)}
        >
          {this.renderItem(item)}
        </div>
        {showValidMsg &&
          <div style={{ width: WForm.validMsgColumnWidth }}>
            {this.renderAssistentValidMsg(item)}
          </div>
        }
      </div>
      <div
        style={{ width }}
      >
        {elemAfter}
      </div>
    </div>
  }

  renderAssistentValidMsg(item: WFormConfigItem, forCombi = false, combiLabel?: string): JSX.Element {
    const { validationMsg, validMsgPopupStyle } = this.state;
    let validMsg = validationMsg[item.key];
    const elk = getErrorLevelKey(validMsg);
    validMsg = removeErrorLevelAddOn(validMsg);
    const params: any = getMessageParams(validMsg) || {};
    const sysTxt = renderText(params.key, this.props.globalData, false, true);

    if (Array.isArray(item.combination_fields)) {
      // Combination
      const combiVMsg: JSX.Element[] = [];
      item.combination_fields.forEach((itemKey: string) => {
        const vMsg = this.renderAssistentValidMsg({ key: itemKey, label: undefined, typ: undefined }, true, item.label);
        if (vMsg) {
          combiVMsg.push(vMsg);
        }
      });
      if (combiVMsg.length > 0) {
        const hasFieldsname: boolean = Array.isArray(item.combination_fields_name) && item.combination_fields_name.length > 0;
        return (
          <div
            style={{
              position: 'relative',
              ...(hasFieldsname ? { minHeight: 10 } : { minHeight: 30 }) // WICHTIG!
            }}
          >
            {combiVMsg.map((vMsg: JSX.Element) =>
              <div style={{ position: 'absolute' }}>
                {vMsg}
              </div>)}
          </div>
        );
      } else {
        return null;
      }
    } else if (item.combination_item !== true || forCombi) {
      // Einzelitem
      if (validMsg) {
        const onFocused = item.showFullValidMsg || (validMsgPopupStyle[item.key] && validMsgPopupStyle[item.key].onFocused);
        return (
          <div
            className={classNames(formStyle.validationWarning, formStyle[`errorlevel_${elk}`])}
            style={{
              ...(item.validMsgStyle || {}),
              ...validMsgPopupStyle[item.key],
              ...(onFocused ? { zIndex: 10 } : {}),
              ...(sysTxt && !onFocused ? { cursor: 'help' } : {}),
              ...(sysTxt && onFocused ? {} : { maxWidth: WForm.maxValidMsgWidth, hyphens: 'auto' }),
              ...((this.props.customCssStyle || {}).validationWarning ? this.props.customCssStyle.validationWarning : {}),
            }}
            ref={(ref) => {
              if (ref) {
                this.initValidMsgPopupStyle(ref, item, forCombi, combiLabel);
              }
            }}
            onClick={() => this.setFocusedItem(item.key)}
          >
            {validMsg}
            {onFocused ? sysTxt :
              sysTxt ?
                <div style={{ fontSize: '0.8em', fontStyle: 'italic' }}>... vollständige Informationen</div> :
                null
            }
          </div>
        );
      }
    }
    return null;
  }

  initValidMsgPopupStyle(ref: any, item: WFormConfigItem, forCombi: boolean, combiLabel?: string) {
    const { validMsgPopupStyle } = this.state;
    const msgDiv: any = forCombi ?
      ((ref.parentElement || {}).parentElement || {}).parentElement || {}
      : ref.parentElement;
    const fieldDiv: any = msgDiv.previousElementSibling || {};
    const fieldDivHeight = fieldDiv.offsetHeight;
    const myHeight = ref.offsetHeight;
    let myTop: number = Math.round((fieldDivHeight - myHeight) / 2);
    myTop += forCombi && combiLabel ? 15 : 3;

    if (!validMsgPopupStyle[item.key]) {
      validMsgPopupStyle[item.key] = {
        onFocused: false
      } as any;
    }
    if (validMsgPopupStyle[item.key].top !== myTop) {
      validMsgPopupStyle[item.key] = { ...validMsgPopupStyle[item.key], top: myTop };
      this.setState(validMsgPopupStyle);
    }
  }

  setFocusedItem(itemKey: string) {
    const { validMsgPopupStyle } = this.state;
    // Combination hat keinen eigenen key
    if (itemKey && typeof itemKey === 'string') {
      Object.keys(validMsgPopupStyle).forEach((iKey: string) => {
        if (iKey === itemKey) {
          validMsgPopupStyle[iKey] = { ...validMsgPopupStyle[iKey], onFocused: true }
        } else {
          validMsgPopupStyle[iKey] = { ...validMsgPopupStyle[iKey], onFocused: false }
        }
      });
      this.setState({ validMsgPopupStyle });
    }
  }

  renderItemsByGroupOrder(items: Array<any>) {
    const isAssistentLayout: boolean = this.props.layout === 'flowV' || this.props.layout === 'flowV2' || this.props.layout2 === 'assistent';
    const validationMsg = this.state.validationMsg || {};
    const showValidMsg: boolean = isAssistentLayout && Object.keys(validationMsg).length > 0;
    const group = this.props.groupOrder;
    const elemBefore = this.props.extraElementBefore;
    const elemAfter = this.props.extraElementAfter;
    const { groupFolded } = this.state;
    return (
      <div
        style={{
          ...(isAssistentLayout ? { width: '100%', overflow: 'visible' } : {})
        }}
      >
        {Array.isArray(group) && group.map((g: any, i: number) => <div>
          {typeof g.title === 'string' && <div
            style={{ display: 'flex', marginBottom: 10, ...(g.titleStyle || {}) }}
            onClick={() => {
              if (g.foldable === true) {
                groupFolded[i] === true ? groupFolded[i] = false : groupFolded[i] = true;
                this.setState({ groupFolded });
              }
            }}
          >
            {g.title}
            {g.foldable === true && <div style={{ marginLeft: 10, fontSize: '0.8em', cursor: 'pointer' }}>
              {groupFolded[i] === true ? '▲' : '▼'}
            </div>}
          </div>}
          {Array.isArray(g.fields) && <div
            style={{
              display: groupFolded[i] === true ? 'none' : 'block'
            }}
          >
            {g.fields.map((key: string, idx: number) => {
              const itm = items.find((it: any) => it.key === key);
              if (itm) {
                const itemElemBefore = (elemBefore || {})[itm.key || itm.id];
                const itemElemAfter = (elemAfter || {})[itm.key || itm.id];
                return this.renderItemWrapper(itm, showValidMsg, itemElemBefore, itemElemAfter);
              }
              return null;
            })}
          </div>}
        </div>)}
      </div>
    );
  }
  handleKeyPress(event: any) {
    if (this.props.saveOnEnter) {
      if (event.key === 'Enter') {
        this.onClickSave();
      }
    }
  }
  renderLabel(item: WFormConfigItem, labelText: JSX.Element, labelClass: string, labelStyle?: React.CSSProperties) {
    const disableHelp = item.disableHelp;
    if (this.props.hideLabels || item.hidden_label) {
      return null;
    }
    return (
      <div
        className={labelClass}
        style={{
          ...(labelStyle || {}),
          justifyContent: 'flex-start'
        }}
      >
        {(this.props.showFieldsHelp && this.props.posFieldsHelpBeginning && !disableHelp) && this.renderFieldsHelp(item)}
        <div
          style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', whiteSpace: 'pre-wrap',
            height: '100%', overflow: 'hidden',
            // flex: item.typ === 'select' ?  1 : null,
            ...(item.combination_item ? { alignItems: 'end' } : {})
          }}
        >
          {labelText}
          {this.props.infoMsg && this.props.infoMsg[item.key] &&
            <div className={formStyle.infoMsg}>{this.props.infoMsg[item.key]}</div>}
          {(this.props.showFieldsHelp && !this.props.posFieldsHelpBeginning && !disableHelp) && this.renderFieldsHelp(item)}
        </div>
      </div>
    );
  }
  renderLabelText(item: WFormConfigItem, extra?: string) {
    if (item.label_right) {
      return (
        <div
          className={style.rowContainer}
          style={{ width: '100%', justifyContent: 'space-between', hyphens: 'auto' }}
        >
          <div>{i18n2(item.label) + (extra || '')}</div>
          <div>{i18n2(item.label_right) + (extra || '')}</div>
        </div>
      );
    } else {
      return (
        <div style={{ hyphens: 'auto' }}>
          {i18n2(item.label) + (extra || '')}
        </div>
      );
    }
  }
  getBundleData(item: any) {
    let bundleData = null;
    if (item) {
      if (this.props.bundle && item.bundle_key && this.props.bundle[item.bundle_key]) {
        bundleData = this.props.bundle[item.bundle_key];
      } else if (this.props.bundle && this.props.bundle[item.key]) {
        bundleData = this.props.bundle[item.key];
      } else {
        bundleData = item.options;
      }
    }
    return bundleData;
  }
  renderCombination(item: WFormConfigItem): JSX.Element {
    const isAssistentLayout: boolean = this.props.layout === 'flowV' || this.props.layout === 'flowV2' || this.props.layout2 === 'assistent';
    const isComplexLayout: boolean = this.props.layout === 'sidebysideComplex' || this.props.layout === 'sidebysideComplexGreen';
    const itmCopy: any = { ...item };

    if (Array.isArray(itmCopy.combination_fields) && itmCopy.combination_fields.length > 1) {
      const propsItems = this.props.config ? this.props.config.items || [] : [];
      const itm1 = propsItems.find((itm: any) => itm.key === itmCopy.combination_fields[0]);
      const itm2 = propsItems.find((itm: any) => itm.key === itmCopy.combination_fields[1]);

      if (itm1 && itm2) {
        const itm1Copy: any = { ...itm1 };
        const itm2Copy: any = { ...itm2 };
        const isItem1Hidden: boolean = !!itm1Copy.hidden || false;
        const isItem1HiddenInput: boolean = !!itm1Copy.hidden_input || false;
        const isItem2Hidden: boolean = !!itm2Copy.hidden || false;
        const isItem2HiddenInput: boolean = !!itm2Copy.hidden_input || false;

        // Hidden
        if ((isItem1Hidden || isItem1HiddenInput) && (isItem2Hidden || isItem2HiddenInput)) {
          if (isAssistentLayout) {
            return null;
          }
        }

        if (isAssistentLayout) {
          // Assistent
          itm1Copy.disableHelp = true;
          itm2Copy.disableHelp = true;
          if (Array.isArray(itmCopy.combination_fields_name) && itmCopy.combination_fields_name.length > 0) {
            // Custom-Title in Felder setzen.
            itm1Copy.label = itmCopy.combination_fields_name[0] || '';
            itm2Copy.label = itmCopy.combination_fields_name[1] || '';
          }
          if (!itmCopy.label) {
            // Gibt es kein Title, nutze die zweite Hilfe, jedoch mit einem kombinierten helpKey.
            itmCopy.hidden_label = true;
            // itm2Copy.disableHelp = false;
            // itm2Copy.helpKey = `${itm1Copy.key}_${itm2Copy.key}`;
            if (isItem2Hidden) {
              itm1Copy.disableHelp = false;
              itm1Copy.helpKey = `${itm1Copy.key}_${itm2Copy.key}`;
            } else {
              itm2Copy.disableHelp = false;
              itm2Copy.helpKey = `${itm1Copy.key}_${itm2Copy.key}`;
            }
          }
        } else if (isComplexLayout) {
          // Hidden
          if (isItem1Hidden && isItem2Hidden) {
            return null;
          }
          // Tapete
          itm1Copy.hidden_label = true;
          itm2Copy.hidden_label = true;
          if (itmCopy.label && Array.isArray(itmCopy.combination_fields_name) && itmCopy.combination_fields_name.length > 0) {
            itmCopy.label = `${itmCopy.label} (${itmCopy.combination_fields_name.join(' / ')})`;
          } else {
            itmCopy.label = itmCopy.label || `${itm1Copy.label} / ${itm2Copy.label}`;
          }
        }

        itmCopy.helpKey = `${itm1Copy.key}_${itm2Copy.key}`;
        itmCopy.label = itmCopy.label || '';
        const labelText = this.renderLabelText(itmCopy);
        const labelStyle = isAssistentLayout ? { paddingBottom: 0 } : {};
        const label = this.renderLabel(itmCopy, labelText, formStyle.label, labelStyle);
        const styleFieldBox: React.CSSProperties = isAssistentLayout && isItem2Hidden
          ? { paddingRight: 0 } : {};
        const styleItem1: React.CSSProperties = {
          ...(isAssistentLayout ? { marginBottom: -20 } : {}),
          ...(isItem2Hidden
            ? (!isItem1Hidden ? { width: '100%' } : {})
            : (isItem1Hidden ? { width: 0 } : {}))
        };
        const styleItem2: React.CSSProperties = {
          ...(isAssistentLayout ? { marginBottom: -20, marginRight: -10, marginLeft: 10 } : { paddingLeft: 3 }),
          ...(isItem1Hidden
            ? (!isItem2Hidden ? { width: '100%' } : {})
            : (isItem2Hidden ? { width: 0 } : {}))
        };

        const combiFieldKey = itmCopy.key || getCombiFieldKey(itmCopy.combination_fields);
        const krCls = getKomplexRowClassname((this.state.data.getAllValues() || {})._formKey, combiFieldKey) || undefined;

        return (
          <div className={classNames(formStyle.fieldBox, krCls)} style={styleFieldBox}>
            {label}
            <div
              className={classNames(formStyle.input, formStyle.fieldCombi)}
              style={{ flexDirection: 'row', ...(isAssistentLayout && { alignItems: 'end' }) }}
            >
              <div
                className={classNames(formStyle.combiBox)}
                style={styleItem1}
                onFocus={() => this.setFocusedItem(itm1Copy.key)}
              >
                {this.renderItem(itm1Copy, null, true)}
              </div>
              <div
                className={classNames(formStyle.combiBox)}
                style={styleItem2}
                onFocus={() => this.setFocusedItem(itm2Copy.key)}
              >
                {this.renderItem(itm2Copy, null, true)}
              </div>
            </div>
          </div>
        );
      }
    }

    return null;
  }

  setWarnOnClick(event: any, mouseClickInfo: any): void {
    mouseClickInfo.posX = event.target.getBoundingClientRect().left;
    mouseClickInfo.posY = event.target.getBoundingClientRect().top;
    this.setState({ mouseClickInfo });
  }

  setWarnRef(elem: any, item: any, formValues: any): void {
    // Siehe auch onFormChangeAbrechnungszeitraumAutoOpenDialog
    if (elem && elem.click) {
      if (item.key) {
        const hasElements: boolean = !!(this.triggerService.hasRegistered('WFormWarnOnClick', `${formValues.tid}_${item.key}`) || []).length;
        if (elem.checkVisibility()) {
          if (hasElements) {
            this.triggerService.clearRegisteredId('WFormWarnOnClick', `${formValues.tid}_${item.key}`);
          }
          this.triggerService.register('WFormWarnOnClick', `${formValues.tid}_${item.key}`, () => elem.click());
        }
      } else if (Array.isArray(item.combination_fields)) {
        item.combination_fields.forEach((itmKey: string) => {
          const hasElements: boolean = !!(this.triggerService.hasRegistered('WFormWarnOnClick', `${formValues.tid}_${itmKey}`) || []).length;
          if (elem.checkVisibility()) {
            if (hasElements) {
              this.triggerService.clearRegisteredId('WFormWarnOnClick', `${formValues.tid}_${itmKey}`);
            }
            this.triggerService.register('WFormWarnOnClick', `${formValues.tid}_${itmKey}`, () => elem.click());
          }
        });
      }
    }
  }

  renderMouseClickInfo(): JSX.Element {
    const { mouseClickInfo } = this.state;
    if (mouseClickInfo.isAlert && mouseClickInfo.text) {
      this.setState({ mouseClickInfo: undefined });
      alert(mouseClickInfo.text);
      return null;
    }
    return (
      <div>
        <SimpleDialog
          title='Hinweis'
          content={
            <div>
              <pre
                style={{ whiteSpace: 'break-spaces', ...(mouseClickInfo.key && { borderBottom: '2px black dotted', paddingBottom: 10 }) }}
              >
                {mouseClickInfo.info || ''}
              </pre>
              {!!mouseClickInfo.text
                ? <span style={{ whiteSpace: 'pre-line' }}>{mouseClickInfo.text}</span>
                : mouseClickInfo.key && renderText(mouseClickInfo.key, this.props.globalData)
              }
            </div>
          }
          titleStyle={{ textDecoration: 'underline' }}
          // dialogStyle={{ backgroundColor: 'rgba(255, 255, 200, 0.9)' }}
          dialogStyle={{ backgroundColor: 'rgb(255, 255, 200)' }}
          // onClick={() => this.setState({ mouseClickInfo: undefined })}
          onClose={() => this.setState({ mouseClickInfo: undefined })}
          setDialogPosition={(dw: number, dh: number, callback: (top: number, left: number) => void) => {
            const mx = mouseClickInfo.posX;
            const my = mouseClickInfo.posY;
            const dt = Math.max(my - dh / 2, 0);
            const dl = Math.max(mx - dw / 2, 0);
            callback(dt, dl);
          }}
        />
      </div>
    );
  }
}
